const STORAGE_USER_KEY = 'STORAGE_USER_KEY'


export default {
	// 获取
	getLocal(key = STORAGE_USER_KEY) {
		return JSON.parse(window.localStorage.getItem(key))
	},
	// 写入
	setLocal(res, key = STORAGE_USER_KEY, isSaveOldData = false) {
		if (isSaveOldData) {
			let oldData = this.getLocal(key)
			return window.localStorage.setItem(key, JSON.stringify(oldData.concat(res)))
		}
		return window.localStorage.setItem(key, JSON.stringify(res))
	}
}



// const STORAGE_USER_KEY = 'STORAGE_USER_KEY'

// export default {
//     // 获取
//     getLocal(key = STORAGE_USER_KEY) {
//         const val = window.localStorage.getItem(key);
        
//         // 【核心修复】如果取不到值（为 null），直接返回 null，不再进行 JSON.parse
//         if (!val) {
//             return null; 
//         }

//         try {
//             return JSON.parse(val);
//         } catch (e) {
//             // 防止存入了非 JSON 格式的脏数据导致报错
//             console.error('LocalStorage 解析失败:', e);
//             return null;
//         }
//     },

//     // 写入
//     setLocal(res, key = STORAGE_USER_KEY, isSaveOldData = false) {
//         if (isSaveOldData) {
//             let oldData = this.getLocal(key);
            
//             // 防御性编程：确保旧数据是数组才能 concat
//             if (!Array.isArray(oldData)) {
//                 oldData = [];
//             }
            
//             return window.localStorage.setItem(key, JSON.stringify(oldData.concat(res)));
//         }
//         return window.localStorage.setItem(key, JSON.stringify(res));
//     }
// }